/**
 * Lightweight hover/focus-visible tooltip using Tailwind (no extra deps).
 * Content is supplementary; give the trigger a proper aria-label/name for AT.
 */
function Tooltip({
  /** Text or node shown above (or below) the trigger when hovered or focused-within */
  content,
  children,
  placement = "top",
  className = "",
}) {
  if (!content) {
    return children;
  }

  const bubbleBase =
    "pointer-events-none absolute z-20 w-max max-w-[min(18rem,calc(100vw-3rem))] whitespace-nowrap rounded-md bg-mainDark px-2 py-1.5 text-left text-[11px] font-normal leading-snug text-mainWhite opacity-0 shadow-lg ring-1 ring-black/10 transition-opacity delay-75 duration-200 group-hover:opacity-100 group-focus-within:opacity-100 dark:bg-white dark:text-neutral-950 dark:ring-neutral-950/10";

  const position =
    placement === "bottom"
      ? "left-1/2 top-full mt-1.5 -translate-x-1/2"
      : "bottom-full left-1/2 mb-1.5 -translate-x-1/2";

  return (
    <span className={`group relative inline-flex shrink-0 ${className}`}>
      {children}
      <span aria-hidden className={`${bubbleBase} ${position}`}>
        {content}
      </span>
    </span>
  );
}

export default Tooltip;
